
import { defuFn } from '/opt/buildhome/repo/node_modules/nuxt/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}



export default defuFn(inlineConfig)
